export default __webpack_public_path__ + "static/media/about_me.0bbee21b.png";